module.exports = __webpack_public_path__ + "img/chests_open.116671b5.svg";